import React from "react";
import { Plugin } from "slate-react";
import { INLINES } from "../html";

const { type } = INLINES.IMAGE;

/**
 * Slate plugin to handle <img> tags
 */
export const Image: Plugin[] = [
  {
    renderInline: (props, controller, next) => {
      const { node } = props;
      if (node.type === type) {
        const src = node.data.get("src");
        const alt = node.data.get("alt");
        const className = node.data.get("className");
        return (
            <img src={src} alt={alt} className={className} />
        );
      }
      else {
        return next();
      }
    },
  },
];
